module.exports = __webpack_public_path__ + "media/images/top/original03-1fe45c36dc7f4b40f577e5f1fce92a60.jpg";